<template>
    <div>
        <blockquote>
            <h5>
                <p>
                    <strong>{{$t('Bareme.etape2.resultat.baremeDetermine')}}</strong>
                    {{dossier.bareme}}
                </p>
            </h5>
        </blockquote>
    </div>
</template>

<script>
export default {
  name: 'SectionResultatBareme',
  props: ['dossier'],
};
</script>

<style scoped>

</style>
